import { Row } from 'antd';
import React, { useState } from 'react';
import PropTypes from 'prop-types';

import OnTraccrCheckbox from '../common/inputs/OnTraccrCheckbox';
import LabelSelector from '../labels/LabelSelector';

export default function BucketOverrideLabelFormItem({
  value,
  onChange,
  isDisplay,
  type,
}) {
  const [overrideLabelChecked, setOverrideLabelChecked] = useState(!!value);

  return (
    <Row>
      <OnTraccrCheckbox
        label="Override Label"
        value={overrideLabelChecked}
        onChange={(newValue) => {
          setOverrideLabelChecked(newValue);
          onChange(newValue ? [] : undefined);
        }}
        disabled={isDisplay}
        hoverNode="Enabling this will override the labels of the downstream equipment with the labels you provide below."
        style={{ marginTop: 5, marginRight: 10 }}
      />
      <LabelSelector
        onChange={onChange}
        value={value || []}
        isDisplay={isDisplay || !overrideLabelChecked}
        type={type}
        style={{ width: 350 }}
      />
    </Row>
  );
}

BucketOverrideLabelFormItem.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  isDisplay: PropTypes.bool,
  type: PropTypes.string.isRequired,
};

BucketOverrideLabelFormItem.defaultProps = {
  value: undefined,
  onChange: null,
  isDisplay: false,
};
